import ProfileDropdown from "./ProfileDropdown";
import { OptimizedSvg } from "@components/common/OptimizedSvg";
import { userProfile } from "@tvet-mis/psda-assets";
import { useProfile } from "./services/GetProfile";
import isEmpty from "@utils/isEmpty";
import { useGetFileUrl } from "@features/RegisterInstitute/services/fileDownload";
import { CircularProgress } from "@mui/material";

const Profile = () => {
	const { data } = useProfile();
	const profilePicture = data?.profilePicture;
	const firstName = data?.firstName;
	const lastName = data?.lastName;

	const { data: profilePictureUrl, isLoading: isLoadingUrl } = useGetFileUrl(profilePicture, {
		enabled: !!profilePicture,
	});

	const hasName = !isEmpty(firstName) || !isEmpty(lastName);
	const fullName = hasName ? `${firstName || ""} ${lastName || ""}`.trim() : "";

	const avatar = profilePictureUrl ? (
		<img src={profilePictureUrl} alt="Profile" />
	) : isLoadingUrl ? (
		<CircularProgress size={24} />
	) : (
		<OptimizedSvg
			src={userProfile}
			alt="user profile"
			className="header-profile-avatar__svg"
			cacheKey="user-profile"
			width={38}
			height={38}
		/>
	);

	return (
		<div className="header-profile-pill" data-testid="profile">
			<div className="header-profile-avatar">{avatar}</div>
			{hasName && (
				<div className="hidden min-w-0 sm:block">
					<div
						className="truncate font-medium max-w-[80px] md:max-w-[150px] lg:max-w-[100px]"
						title={fullName}>
						{fullName}
					</div>
				</div>
			)}

			<div className="header-profile-chevron">
				<ProfileDropdown />
			</div>
		</div>
	);
};

export default Profile;
